import { supabase } from './supabase.js';

/**
 * Suscripción al boletín de Noticias (insert + email de bienvenida vía Edge Function).
 * @param {string} email
 * @returns {Promise<{ ok: boolean, alreadySubscribed?: boolean, emailSent?: boolean, error?: string }>}
 */
export async function subscribeNoticiasNewsletter(email) {
  const raw = String(email ?? '').trim();
  if (!raw) return { ok: false, error: 'Escribe tu correo electrónico.' };

  const { data, error } = await supabase.functions.invoke('noticias-newsletter-subscribe', {
    body: { email: raw },
  });

  if (error) {
    console.error('[noticiasNewsletterService] invoke:', error.message);
    return { ok: false, error: 'No se pudo completar la suscripción. Inténtalo más tarde.' };
  }

  if (data?.error === 'invalid_email') {
    return { ok: false, error: 'Revisa que el correo sea válido.' };
  }

  if (data?.error) {
    return { ok: false, error: data?.message || 'No se pudo guardar la suscripción.' };
  }

  return {
    ok: true,
    alreadySubscribed: !!data?.already_subscribed,
    emailSent: !!data?.email_sent,
  };
}
